<template>
  <div>
    <v-list-item class="pl-0 pr-4">
      <v-list-item-icon class="mr-2">
        <v-icon color="primary" x-large>mdi-check-circle</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <p class="ma-0"><slot></slot></p>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
